module.exports = __webpack_public_path__ + "static/media/BG_26.e7df1d2b.png";